import arrow from "../../assets/design-revamp/dropdown-icons/arrow-dropdown.svg";

const AutocompleteArrow = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={arrow}
          alt=""
          style={{ ...style, width: "14px", height: "14px" }}
        />
      </div>
    </>
  );
};

export default AutocompleteArrow;
